export class BezierCurve {
    /**
     * Prvni bod krivky
     */
    p1 = new pc.Vec2();
    /**
     * Vrchol krivky
     */
    p2 = new pc.Vec2();
    /**
     * Posledni bod krivky
     */
    p3 = new pc.Vec2();

    private static _tmpPos = new pc.Vec2();

    //-------------------------------------------------------------------------
    /**
     * Ziskani pozice na krivce
     * @param t 0 az 1
     * @returns 
     */
    //-------------------------------------------------------------------------
    getPos(t: number): pc.Vec2 {
        let p = BezierCurve._tmpPos;

        p.x = Math.pow(1 - t, 2) * this.p1.x + 2 * (1 - t) * t * this.p2.x + Math.pow(t, 2) * this.p3.x;
        p.y = Math.pow(1 - t, 2) * this.p1.y + 2 * (1 - t) * t * this.p2.y + Math.pow(t, 2) * this.p3.y;

        return p;
    }

    //-------------------------------------------------------------------------
    /**
     * @returns Vraci delku krivky
     */
    //-------------------------------------------------------------------------
    getLength(): number {
        let ax = this.p1.x - 2 * this.p2.x + this.p3.x;
        let ay = this.p1.y - 2 * this.p2.y + this.p3.y;
        let bx = 2 * this.p2.x - 2 * this.p1.x;
        let by = 2 * this.p2.y - 2 * this.p1.y;
        let A = 4 * (ax * ax + ay * ay);
        let B = 4 * (ax * bx + ay * by);
        let C = bx * bx + by * by;

        let Sabc = 2 * Math.sqrt(A + B + C);
        let A_2 = Math.sqrt(A);
        let A_32 = 2 * A * A_2;
        let C_2 = 2 * Math.sqrt(C);
        let BA = B / A_2;

        return (A_32 * Sabc + A_2 * B * (Sabc - C_2) + (4 * C * A - B * B) * Math.log((2 * A_2 + BA + Sabc) / (BA + C_2))) / (4 * A_32);
    }
}